/**
 * Only add the ones that you really need as including whole core-js is approximately 300 KB
 */

// Array and object methods for making life easier with IE 11
import 'core-js/features/array';
import 'core-js/features/object';
// NodeList.forEach for IE 11
import 'core-js/stable/dom-collections/for-each';

// Promises for.. pretty much everything
import 'core-js/features/promise';

import 'objectFitPolyfill';

// Element.matches() IE9+ support
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

// Element.closest() IE9+ support, requires Element.matches (or polyfill)
if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

// Enable when adding new polyfills
const DEBUG_POLYFILLS = false;

// Add test and run with the browser you want to polyfill.
if(DEBUG_POLYFILLS) {
  const res = [];
  // Array.protype.find
  // One polyfilled method should do, as we're importing all array methods
  ['foo'].find(item => { res.push('Array.prototype.find()') });

  // Object.prototype.assign()
  // One polyfilled method should do, as we're importing all object methods
  const assign = Object.assign({}, {test: 'Object.prototype.assign()'});
  res.push(assign.test);

  // Promise
  new Promise((resolve, reject) => {
    res.push('Promise');
    resolve();
  });

  // NodeList.prototype.forEach()
  document.querySelectorAll('body').forEach(el => {
    res.push('NodeList.prototype.forEach()');
  });

  console.info('Polyfill debug', res);
}

// Adds object-fit for video elements on ie11
// window.addEventListener('load', () => {
//   objectFitPolyfill(document.querySelectorAll('video.js-object-fit'));
// });
